import * as React from 'react'

// Constants
import { DOWNLOAD_TYPE } from '../../../constants'

// Modules
import { DI } from 'modules'

// Helpers
import { plural } from 'helpers/strings'

const DISPLAYED_TYPE = {
  pool: 1,
  regular_content: 2,
  spherical: 3,
}

const DSAEnterpriseLimitLeft = ({ agreement, common: { strings } }) => {
  const { balance, refill_in, user_balance } = agreement
  const { download_type } = agreement.can_download_content

  const buyPlanCln = 'side-buy-plan'
  const prefix = 'page.video.limit_left'
  const topUpQuota = user_balance.top_up_quota || balance.top_up_quota
  const displayedTypeIndex = DISPLAYED_TYPE[user_balance.limit_type] || 4
  const videoTypeText =
    strings[`page.video.slider.enterprise.video_type_${displayedTypeIndex}`]
  const isUnlimitedAccess =
    balance.unlimited_access && !user_balance.customized_limit
  const quota = agreement.user_balance.quota || agreement.balance.quota

  return (
    <>
      <div className={`${buyPlanCln}__text`}>
        {isUnlimitedAccess && strings[`${prefix}.unlimited`]}
        {quota && plural(quota, videoTypeText)}
      </div>

      {download_type === DOWNLOAD_TYPE.TOP_UP && (
        <>
          <div className={`${buyPlanCln}__text`}>
            {strings[`${prefix}.top_up_1`]}
          </div>
          {refill_in && (
            <div className={`${buyPlanCln}__text`}>
              {strings[`${prefix}.top_up_2`]}
              {refill_in}
              {strings[`${prefix}.top_up_3`]}
            </div>
          )}
          <p />
          <div className={`${buyPlanCln}__text`}>
            {topUpQuota}
            {strings[`${prefix}.top_up_4`]}
            {plural(topUpQuota, videoTypeText)}
            {strings[`${prefix}.top_up_5`]}
            {balance.top_up_item_price}
            {strings[`${prefix}.top_up_6`]}
          </div>
        </>
      )}
      {download_type === DOWNLOAD_TYPE.RESTRICTED && (
        <div className={`${buyPlanCln}__text`}>
          {plural(quota, videoTypeText)}
        </div>
      )}
    </>
  )
}

export default DI(['common'])(DSAEnterpriseLimitLeft)
